module.exports = "<app-data></app-data>\n"